import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const StarsIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 24 24" fill="none">
      <path
        d="M14.8239 2.40002L16.6542 7.34623L21.6004 9.1765L16.6542 11.0068L14.8239 15.953L12.9937 11.0068L8.04745 9.1765L12.9937 7.34623L14.8239 2.40002Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6.35333 13.6941L7.95216 16.0483L10.3063 17.6471L7.95216 19.2459L6.35333 21.6L4.75451 19.2459L2.40039 17.6471L4.75451 16.0483L6.35333 13.6941Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default StarsIcon;
